<template>
  <header
    :class="[
      'fixed top-0 inset-x-0 z-50 transition-all duration-300',
      scrolled ? 'bg-base/85 backdrop-blur-xl border-b border-line' : 'bg-transparent border-b border-transparent',
    ]"
  >
    <nav class="container-app flex items-center justify-between h-16 sm:h-[72px]">
      <!-- Logo -->
      <a href="/" class="flex items-center gap-2.5 shrink-0">
        <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-9 w-auto" />
        <span class="text-base font-extrabold tracking-tight text-white hidden sm:block">
          Akademi<span class="text-brand">Siber</span>
        </span>
      </a>

      <!-- Desktop nav -->
      <div class="hidden lg:flex items-center gap-1">
        <a
          v-for="link in links"
          :key="link.href"
          :href="link.href"
          :class="[
            'px-3.5 py-2 rounded-lg text-sm font-medium transition-colors',
            isActive(link.href) ? 'text-white bg-surface-light' : 'text-ink-muted hover:text-white hover:bg-surface-light/60',
          ]"
        >
          {{ link.label }}
        </a>
      </div>

      <!-- Desktop actions -->
      <div class="hidden lg:flex items-center gap-3">
        <a href="/login" class="btn-ghost">Login</a>
        <a href="/register" class="btn-primary">
          Get Started
          <i class="fas fa-arrow-right text-xs"></i>
        </a>
      </div>

      <!-- Mobile toggle -->
      <button
        class="lg:hidden h-10 w-10 grid place-items-center rounded-lg text-white hover:bg-surface-light"
        @click="mobileOpen = !mobileOpen"
        aria-label="Toggle menu"
      >
        <i :class="mobileOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
      </button>
    </nav>

    <!-- Mobile menu -->
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0 -translate-y-2"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div v-if="mobileOpen" class="lg:hidden bg-base/95 backdrop-blur-xl border-b border-line">
        <div class="container-app py-4 flex flex-col gap-1">
          <a
            v-for="link in links"
            :key="link.href"
            :href="link.href"
            :class="[
              'px-4 py-3 rounded-lg text-sm font-medium',
              isActive(link.href) ? 'text-white bg-surface-light' : 'text-ink-muted hover:text-white hover:bg-surface-light',
            ]"
          >
            <i :class="[link.icon, 'w-5 text-brand mr-2']"></i>{{ link.label }}
          </a>
          <div class="flex gap-3 mt-3 pt-3 border-t border-line">
            <a href="/login" class="btn-secondary flex-1">Login</a>
            <a href="/register" class="btn-primary flex-1">Get Started</a>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: "PublicNavbar",
  data() {
    return {
      scrolled: false,
      mobileOpen: false,
      links: [
        { label: "Modules", href: "/modules", icon: "fas fa-book" },
        { label: "Machine Labs", href: "/machine-labs", icon: "fas fa-server" },
        { label: "AI Mentored Lab", href: "/ai-labs", icon: "fas fa-robot" },
        { label: "Leaderboard", href: "/leaderboard", icon: "fas fa-trophy" },
        { label: "Pricing", href: "/subscribe", icon: "fas fa-crown" },
      ],
    };
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 8;
    },
    isActive(href) {
      return this.$route.path === href || this.$route.path.startsWith(href + "/");
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
